import { privateApi } from './api';

const customerService = {
  getCustomer: (msisdn: string) => privateApi.get(`/v3/customers/${msisdn}/`),

  getFeatureToggles: (msisdn: string) =>
    privateApi.get(`/customers/${msisdn}/feature_toggles`),

  addRecipient: (msisdn: string, recipientMsisdn: string) =>
    privateApi.post(`/customers/${msisdn}/dependents/${recipientMsisdn}`),

  deleteRecipient: (msisdn: string, recipientMsisdn: string) =>
    privateApi.delete(`/customers/${msisdn}/dependents/${recipientMsisdn}`),

  getRechargeValuesWithAttributes: (msisdn: string) =>
    privateApi.get(`/customers/${msisdn}/recharge-values-with-attributes`),

  addCard: (msisdn: string, token: string) =>
    privateApi.post(`/customers/${msisdn}/cards/${token}`, null),

  favoriteCard: (msisdn: string, token: string) =>
    privateApi.put(`/customers/${msisdn}/cards/${token}/favorite`),

  deleteCard: (msisdn: string, token: string) =>
    privateApi.delete(`/customers/${msisdn}/cards/${token}`),

  deleteCustomer: (msisdn: string, customerId: string) =>
    privateApi.delete(`/v2/customers/${msisdn}/${customerId}`),
};

export default customerService;
